// extracted by mini-css-extract-plugin
export default {"html":"Html_html__EJYXW","divs":"Html_divs__d0r6k","slider":"Html_slider__BSlPj"};